import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { QuestionBase } from '@mmx/shared'

@Component({
  selector: 'mmx-body-question',
  templateUrl: './body-question.component.html',
  styleUrls: ['./body-question.component.scss'],
  standalone: false,
})
export class BodyQuestionComponent implements OnInit {
  @Input() question: QuestionBase<any>
  @Input() form: UntypedFormGroup
  @Input() showSelector = true

  @Input() bodyParts = {
    head: false,
    armLeft: false,
    armRight: false,
    upperBackLeft: false,
    upperBackRight: false,
    lowerBackLeft: false,
    lowerBackRight: false,
    feetLeft: false,
    feetRight: false,
    glutesLeft: false, // gluteus
    glutesRight: false, // gluteus
    handLeft: false,
    handRight: false,
    legLeft: false,
    legRight: false,
    neckLeft: false,
    neckRight: false,
    shoulderLeft: false,
    shoulderRight: false,
  }

  buttonState = 'out'

  constructor() {}

  ngOnInit() {
    this.bodyParts =
      this.form &&
      (this.form.get(this.question.id) as UntypedFormGroup).controls['value'].value
        ? (this.form.get(this.question.id) as UntypedFormGroup).controls['value'].value
        : this.bodyParts
  }

  toggleSelection(part: string): void {
    this.bodyParts[part] = !this.bodyParts[part]
    // update value
    const bodyControl = (this.form.get(this.question.id) as UntypedFormGroup).controls[
      'value'
    ]
    bodyControl.setValue(this.bodyParts)
  }
}
